/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import './heading.css';

import { withTheme } from '../cn';

import Component from './heading';

export default withTheme(Component);
